import { type ComponentProps, type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { PopoverPanel } from "@headlessui/react";

// The box Previous chats and Suggested questions drop into: under the toolbar,
// the width of the pane it opens over (up to 640px), scrolling when long.
// `scroll={false}` lets popovers inside it (the filter lists) overflow the box.
export const DropdownPanel: FC<{
  scroll?: boolean;
  children: ComponentProps<typeof PopoverPanel>["children"];
}> = ({ scroll = true, children }) => (
  <PopoverPanel
    className={clsx(
      "absolute top-full left-0 z-30 mt-1 w-[calc(100%-16px)] max-w-[640px] rounded-lg border border-slate-200 bg-white py-1 shadow-[0_12px_32px_rgba(15,23,42,0.14),0_2px_6px_rgba(15,23,42,0.06)]",
      scroll && "max-h-[min(70vh,560px)] overflow-y-auto",
    )}
  >
    {children}
  </PopoverPanel>
);

// A padded slot at the top of the box (the chat search).
export const DropdownPanelHeader: FC<{ children: ReactNode }> = ({
  children,
}) => <div className="px-3 pt-2 pb-1">{children}</div>;

// A padded row of controls (the Filters box).
export const DropdownPanelRow: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex flex-wrap items-center gap-2 px-3 py-2">{children}</div>
);
